$(document).ready(function () {
    var mobileNav = document.getElementById('mobile-nav');
    var desktopNav = document.getElementById('desktop-nav');
    var navbar = $('#site-navbar-wrap');
    var topAdContainer = $('#top-ad-container');
    var navTop = updateNavTop();
    var topAd = updateTopAd();
    var fixedScrollClass = 'fixed-scroll';
    var fixedScrollOffsetClass = 'fixed-scroll-offset';
    var showAdOverlay = false;
    var topAdIsInit = false;
    var navsMiddleDistance = 0;
    var desktopBreakpointWidth = 1024;
    var isResizing = false; 
    var navTopNeedsAdOffset = false;

    $('meta-nav').on('metaNavLoaded', function () {
        if (window.innerWidth >= desktopBreakpointWidth) {
            resizeDesktopNav();
        }
        updateAnchorOffsets();
        navbar.removeClass('nav-loading');
        $('meta-nav').off('metaNavLoaded');
    });

    window.googletag.cmd.push(function () {
        googletag.pubads().addEventListener('slotOnload', function (event) {
            if (topAdIsInit) return;

            var slot = event.slot;
            var slotEleId = '#' + slot.getSlotElementId();

            //If the ad is a super leaderboard, we need to fix it to the top
            if ($(slotEleId).closest('#leaderboard-ad-desktop').length
                || $(slotEleId).closest('#leaderboard-ad-tablet').length
                || $(slotEleId).closest('#leaderboard-ad-mobile').length) {

                topAdIsInit = true;
                showAdOverlay = true;
                window.addEventListener("message", updateStickyNavOnAdResize);

                updateTopAd();
                if (window.scrollY >= topAd) {
                    fixLeaderboardAdToTopOfScreen();
                    fixNavbarToTopOfScreen();
                }

                setTimeout(function () {
                    if (!navbar.hasClass(fixedScrollClass)) {
                        updateNavTop();
                    } else {
                        navTopNeedsAdOffset = true;
                    }
                    if (topAdContainer.hasClass(fixedScrollClass)) {
                        collapseFixedLeaderboardAd();
                    }
                    showAdOverlay = false;
                    window.removeEventListener("message", updateStickyNavOnAdResize);
                }, 5000);
            }
        });
    });

    function updateStickyNavOnAdResize(event) {
        if (navbar.hasClass(fixedScrollClass)
            && event.data && typeof event.data == 'string'
            && event.data.includes('resize_frame')) {
            updateNavTopOffset();
        }
    }

    $('.desktop-toggle').click(function () {
        desktopNav.classList.toggle('onclick-desktop-nav');
    });

    $('.desktop-nav a.dropdown-toggle').hover(function () {
        $('.desktop-nav a.dropdown-toggle').blur();
        $('.desktop-nav li.dropdown.open').removeClass('open');
    });

    $(desktopNav).on('shown.bs.collapse', function () {
        navbar.on('keydown', '.desktop-toggle', function (e) { if (e.keyCode == 9 && !e.shiftKey) { $(desktopNav).find('a').first().focus(); e.preventDefault(); } });
        navbar.on('keydown', '#desktop-nav .nav > li:first-of-type > a', function (e) { if (e.keyCode == 9 && e.shiftKey) { $(desktopNav).collapse('hide'); desktopNav.classList.toggle('onclick-desktop-nav'); e.preventDefault(); } });
        navbar.on('keydown', '#desktop-nav a.toggle-language-btn', function (e) { if (e.keyCode == 9 && !e.shiftKey) { $(desktopNav).collapse('hide'); desktopNav.classList.toggle('onclick-desktop-nav'); e.preventDefault(); } });
    });

    $(desktopNav).on('hide.bs.collapse', function () {
        navbar.off('keydown', '.desktop-toggle');
        navbar.off('keydown', '#desktop-nav .nav > li:first-of-type > a');
        navbar.off('keydown', '#desktop-nav a.toggle-language-btn');
    });

    $(mobileNav).on('hide.bs.collapse', function () {
        $('.body-wrapper').removeClass('sidenav-opened');
        $('body,html').removeClass('sidenav-opened-desktop');
    });

    $(mobileNav).on('shown.bs.collapse', function () {
        $('.body-wrapper').addClass('sidenav-opened');
        $('body,html').addClass('sidenav-opened-desktop');
        resizeMobileNav();
    });

    //if link is for an anchor (#) tag and we're already on the page, collapse the nav
    $('#mobile-nav a').click(function (e) {
        var currentUrl = $(e.currentTarget).attr('href');
        var urlParts = /(\/.*)(#.*)/g.exec(currentUrl);
        if (urlParts && urlParts[1] === window.location.pathname) {
            $(mobileNav).collapse('hide');
        }
    });

    $(window).on('scroll', function () {

        if (!navbar.hasClass(fixedScrollClass)) {
            navTopNeedsAdOffset = false;
            updateNavTop();
        }

        if (!topAdContainer.hasClass(fixedScrollClass)) {
            updateTopAd();
        }

        if (showAdOverlay) {
            if (window.scrollY >= topAd) {
                if (!navbar.hasClass(fixedScrollClass)) {
                    fixLeaderboardAdToTopOfScreen();
                    fixNavbarToTopOfScreen();
                }
            } else {
                unfixLeaderboardAdFromTopOfScreen();
                unfixNavbarFromTopOfScreen();
            }
        }
        else {
            var scrollCheck = navTopNeedsAdOffset ? navTop + topAdContainer.height() : navTop;
            if (window.scrollY > scrollCheck) {
                if (!navbar.hasClass(fixedScrollClass)) {
                    fixNavbarToTopOfScreen();
                }
            }
            else if (!($('.body-wrapper').hasClass('sidenav-opened'))) {
                unfixNavbarFromTopOfScreen();
            }
        }
    });

    window.addEventListener("pageshow", function (event) {
        var historyTraversal = event.persisted || (typeof window.performance !== "undefined" && window.performance.navigation.type === 2);
        if (historyTraversal === true && iOSDevice() === true && $('.mobile-toggle').hasClass('collapsed') === false) {
            $('.mobile-toggle').click();
        }
    });

    function iOSDevice() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    function collapseFixedLeaderboardAd() {
        var adHeight = topAdContainer.height();
        var offsetToScroll = topAd + adHeight - $(window).scrollTop();
        if (offsetToScroll < 0) {
            offsetToScroll = 0;
        }
        var scrollAd = adHeight - offsetToScroll;

        navbar.animate({
            top: offsetToScroll
        }, 250);

        topAdContainer.animate({
            top: -scrollAd
        }, 250, unfixLeaderboardAdFromTopOfScreen);
    }

    function fixLeaderboardAdToTopOfScreen() {
        updateNavTopOffset();
        topAdContainer.addClass(fixedScrollClass);
    }

    function unfixLeaderboardAdFromTopOfScreen() {
        topAdContainer.removeClass(fixedScrollClass);
        topAdContainer.css('top', '');
        if (navbar.css('top').replace('px', '') > 0) {
            navbar.css('top', '');
            navbar.removeClass(fixedScrollClass);
        }
        $('.' + fixedScrollOffsetClass).css('margin-top', '');
        updateAnchorOffsets();
        $('meta-nav').trigger('resizeSideNav');
    }

    function fixNavbarToTopOfScreen() {
        navbar.addClass(fixedScrollClass);
        navbar.nextAll(':not(script):not(style):not(meta):not(noscript)').first().addClass(fixedScrollOffsetClass);
        if (showAdOverlay) {
            var firstPageElementOffset = navbar.height() + topAdContainer.height();
            $('.' + fixedScrollOffsetClass).css('margin-top', firstPageElementOffset);
        }
    }

    function unfixNavbarFromTopOfScreen() {
                navbar.removeClass(fixedScrollClass);
            $('.' + fixedScrollOffsetClass).css('margin-top', '').removeClass(fixedScrollOffsetClass);
    }

    function updateNavTopOffset() {
        checkAndOffsetNavForAd('leaderboard-ad-desktop');
        checkAndOffsetNavForAd('leaderboard-ad-tablet');
        checkAndOffsetNavForAd('leaderboard-ad-mobile');
    }

    function checkAndOffsetNavForAd(adSelector) {
        var isAdDisplayed = $('#' + adSelector).css('display');
        if (isAdDisplayed && isAdDisplayed !== 'none') {
            navbar.css('top', document.getElementById(adSelector).offsetHeight + "px");
        }
    }

    $(window).on('resize', resizeAfterTimeout);

    function updateNavTop() {
        return navTop = navbar.offset().top;
    }

    function updateTopAd() {
        var topOffset = topAdContainer.offset();
        return topAd = topOffset ? topOffset.top : 0;
    }

    function resizeAfterTimeout() {
        //Limits amount of resize calls
        if (!isResizing) {
            isResizing = true;
            setTimeout(function () {
                resizeNav();
                isResizing = false;
            }, 100);
        }
    }
    
    function resizeNav() {

        if (window.innerWidth >= desktopBreakpointWidth) {
            resizeDesktopNav();
        }
        else {
            removeDesktopToggleButton();
            navbar.removeClass('responsive-desktop-medium');
            navbar.removeClass('responsive-desktop-large');
            navbar.removeClass('responsive-desktop-default');
            navbar.removeClass('responsive-desktop-small');
        }

        resizeMobileNav();
        updateAnchorOffsets();
    }

    function resizeMobileNav() {
        if (mobileNav.classList.contains('in')) {
            $(mobileNav).height(window.innerHeight - mobileNav.getBoundingClientRect().top);

            if (window.innerWidth >= desktopBreakpointWidth) {
                $('.body-wrapper').removeClass('sidenav-opened');
                $('body,html').removeClass('sidenav-opened-desktop');
                $(mobileNav).collapse('hide');
            }
        }
    }

    function updateAnchorOffsets() {
        var topHeight = navbar.height();
        if (showAdOverlay) {
            topHeight = topHeight + topAdContainer.height();
        }
        $('.anchor')
            .css('padding-top', topHeight)
            .css('margin-top', -topHeight);
    }

    function navDistance() {
        var x1 = $("#desktop-nav .nav").offset().left;
        var x2 = $("#meta-nav-menu").offset().left;
        var distance = x2 - x1;
        distance = Math.round(distance - $("#desktop-nav .nav").width());
        return distance;
    }

    function toggleLargeResponsiveClass(navsMiddleSpace) {
        if (navsMiddleSpace <= 64) {
            if (navbar.hasClass('responsive-desktop-default') && !navbar.hasClass('responsive-desktop-large')) {
                navbar.addClass('responsive-desktop-large');
                removeDesktopToggleButton();
            }
        }
    }

    function toggleMediumResponsiveClass() {
        if (navbar.hasClass('responsive-desktop-large')) {
            navbar.removeClass('responsive-desktop-large');
        }
        navbar.addClass('responsive-desktop-medium');
        removeDesktopToggleButton();
    }

    function toggleSmallResponsiveClass() {
        navbar.removeClass('responsive-desktop-medium');
        navbar.removeClass('responsive-desktop-large');
        navbar.removeClass('responsive-desktop-default');
        navbar.addClass('responsive-desktop-small');      
    }

    function removeDesktopToggleButton(){
        desktopNav.classList.remove('onclick-desktop-nav');
        desktopNav.classList.remove('in');
        desktopNav.classList.remove('collapse');
        $('#desktop-nav').collapse('hide');
        $('.desktop-toggle').addClass('collapsed');
    }

    function resizeDesktopNav() {
        navbar.removeClass('responsive-desktop-small');
        navbar.removeClass('responsive-desktop-medium');
        navbar.removeClass('responsive-desktop-large');
        navbar.removeClass('responsive-desktop-default');
        navbar.addClass('responsive-desktop-default');
        navsMiddleDistance = navDistance();
        if (navsMiddleDistance <= 64) {
            toggleLargeResponsiveClass(navsMiddleDistance);
            navsMiddleDistance = navDistance();
            if (navsMiddleDistance <= 64) {
                toggleMediumResponsiveClass(navsMiddleDistance);
                navsMiddleDistance = navDistance();
                if (navsMiddleDistance <= 48) {
                    toggleSmallResponsiveClass(navsMiddleDistance);
                }
            }
        }
    }
});